import type { AccountHistoryItem, FxAccountOverview } from "../../api/kurssicherung.ts";
import { sicherungsNr } from "../../lib/sicherungsNummer.ts";
import { kontoMischkursVerfuegbar } from "../../lib/fxKontostand.ts";
import { hatRecht } from "../../state/berechtigungen.ts";
import { datum, kontoAnzeigenamen, mischkurs, usd } from "./fxAnzeige.ts";

export interface KontenKarteProps {
  konten: readonly FxAccountOverview[];
  legacyUnassigned: readonly AccountHistoryItem[];
  rechte: ReadonlySet<string>;
  onKorrigieren: (konto: FxAccountOverview, ausloeser: HTMLElement) => void;
}

/** Karte "Konten": je Konto Name, Stand, Mischkurs und der Weg zum Dialog "Kontostand korrigieren". */
export function KontenKarte({ konten, legacyUnassigned, rechte, onKorrigieren }: KontenKarteProps) {
  const darfKorrigieren = hatRecht(rechte, "manage_fx");
  const kontoNamen = kontoAnzeigenamen(konten.map((konto) => konto.account));
  // Stillgelegte Konten gehoeren nicht in die Konten-Karte (die Uebersicht liefert ohnehin nur aktive).
  const aktiveKonten = konten.filter((konto) => konto.account.isActive !== false);
  return (
    <section className="fx-overview-card fx-konten" aria-labelledby="fx-konten-titel">
      <div className="fx-overview-card-head"><h2 id="fx-konten-titel">Konten</h2></div>
      <ul className="fx-konten-liste-karte">
        {aktiveKonten.map((konto) => {
          const name = kontoNamen.get(konto.account.id) ?? konto.account.name;
          return (
          <li key={konto.account.id}>
            <div className="fx-konto-kopf"><strong>{name}</strong><button type="button" className="link-btn" disabled={!darfKorrigieren} title={!darfKorrigieren ? "fehlende Berechtigung" : undefined} aria-label={`Kontostand ${name} korrigieren`} onClick={(ereignis) => onKorrigieren(konto, ereignis.currentTarget)}>Korrigieren</button></div>
            {konto.current
              ? <div className="fx-konto-werte"><b>{usd(konto.current.balanceUsd)}</b><span>Mischkurs {kontoMischkursVerfuegbar(konto.current.balanceUsd) && konto.current.mixedRate ? mischkurs(konto.current.mixedRate) : "nicht verfügbar"}</span><span>Stand {datum(konto.current.effectiveOn)}</span></div>
              : <p className="fx-konto-unbekannt">Noch kein Kontostand erfasst</p>}
          </li>
          );
        })}
        {!aktiveKonten.length && <li className="empty-note">Noch kein aktives USD-Konto vorhanden.</li>}
      </ul>
      {legacyUnassigned.length > 0 && (
        <div className="fx-legacy-unassigned" role="note" aria-label="Altbestand nicht zugeordnet">
          <strong>Altbestand nicht zugeordnet</strong>
          <p>Diese Sicherungen sind keinem echten Konto zugeordnet.</p>
          <ul>{legacyUnassigned.map((eintrag) => <li key={eintrag.id}>{eintrag.deal ? `${sicherungsNr(eintrag.deal)} · ${usd(eintrag.deal.usd)}` : datum(eintrag.effectiveOn)}</li>)}</ul>
        </div>
      )}
    </section>
  );
}
